module.exports = __webpack_public_path__ + "img/chat_menu_fill.78ee96c9.svg";